import { z } from 'zod';

export const MAX_TENANT_ADMIN_EMAILS = 25;

export const TenantAdminEmailsSchema = z
  .array(z.email())
  .max(MAX_TENANT_ADMIN_EMAILS);

export const AddTenantAdminsBodySchema = z.object({
  emails: TenantAdminEmailsSchema.min(1),
});

export const TenantAdminAssignmentFailureSchema = z.object({
  email: z.string().min(1),
  message: z.string(),
});

export const TenantAdminAssignmentResultSchema = z.object({
  added: z.array(z.email()),
  invited: z.array(z.email()),
  failed: z.array(TenantAdminAssignmentFailureSchema),
});

export const AddTenantAdminsResponseSchema = z.object({
  added: z.array(z.email()),
  invited: z.array(z.email()),
});

export type AddTenantAdminsBody = z.infer<typeof AddTenantAdminsBodySchema>;
export type TenantAdminAssignmentFailure = z.infer<
  typeof TenantAdminAssignmentFailureSchema
>;
export type TenantAdminAssignmentResult = z.infer<
  typeof TenantAdminAssignmentResultSchema
>;
export type AddTenantAdminsResponse = z.infer<
  typeof AddTenantAdminsResponseSchema
>;
